import { cn } from '@/lib/cn';
import { Section } from '../common/Section';

interface IngredientsTwoColumnSectionProps {
  className?: string;
  children: React.ReactNode;
}

export const IngredientsTwoColumnSection = ({
  className,
  children,
}: IngredientsTwoColumnSectionProps) => {
  return (
    <Section
      containerClassName="lg:pb-0 lg:pt-0 py-0"
      className={cn(
        'flex grid-cols-[37.5rem_1fr] flex-col items-start justify-between gap-12 lg:grid lg:gap-17.5',
        className,
      )}
    >
      {children}
    </Section>
  );
};
